// extracted by css-extract-rspack-plugin
export default {"cls1":"ContinueReadingWorkCard-cls1_JDc","cls2":"ContinueReadingWorkCard-cls2_3mn ContinueReadingWorkCard-cls1_JDc"};